module.exports = __webpack_public_path__ + "static/casfer-brand-0701ac4aec1afc4b4f8e096887c8d83b.svg";